module.exports = __webpack_public_path__ + "static/media/audience_black.4e1076a5.svg";